import { render, staticRenderFns } from "./GroupedProduct.vue?vue&type=template&id=1f516e93&scoped=true&"
import script from "./GroupedProduct.vue?vue&type=script&lang=ts&"
export * from "./GroupedProduct.vue?vue&type=script&lang=ts&"
import style0 from "./GroupedProduct.vue?vue&type=style&index=0&id=1f516e93&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f516e93",
  null
  
)

export default component.exports